import i18next from 'i18next';
import * as yup from 'yup';
import { AnyObject, Maybe } from 'yup/lib/types';

yup.addMethod<yup.NumberSchema>(
  yup.number,
  'decimal',
  function (maxWhole: number = 8, maxFraction: number = 4) {
    return this.test('decimal', function (value) {
      const { path, createError } = this;

      // At this point we do not care if the value is falsy
      if (!value || Number.isNaN(value)) {
        return true;
      }

      const valueParts = String(value).split('.');
      const valueWhole = valueParts[0];
      const valueFraction = valueParts[1] ?? '';

      if (String(value).length > maxWhole + maxFraction + 1) {
        return createError({
          path,
          message: i18next.t('Decimal value too long', {
            maxWhole,
            maxFraction,
          }),
        });
      }

      if (valueWhole.length > maxWhole) {
        return createError({
          path,
          message: i18next.t('Decimal whole part too long', {
            maxWhole,
          }),
        });
      }

      if (valueFraction.length > maxFraction) {
        return createError({
          path,
          message: i18next.t('Decimal fraction part too long', {
            maxFraction,
          }),
        });
      }

      return true;
    });
  }
);

yup.addMethod<yup.NumberSchema>(yup.number, 'percentage', function () {
  return this.decimal().test('percentage', function (value) {
    const { path, createError } = this;

    // At this point we do not care if the value is falsy
    if (!value || Number.isNaN(value)) {
      return true;
    }

    if (value < 0) {
      return createError({ path, message: '0% is minimum value' });
    }

    if (value > 100) {
      return createError({ path, message: '100% is maximum value' });
    }

    return true;
  });
});

declare module 'yup' {
  interface NumberSchema<
    TType extends Maybe<number> = number | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType
  > extends yup.BaseSchema<TType, TContext, TOut> {
    decimal(
      maxWhole?: number,
      maxFraction?: number
    ): NumberSchema<TType, TContext>;
    percentage(): NumberSchema<TType, TContext>;
  }
}

export default yup;
